import { WHATSAPP_NUMBER } from "@/i18n/content";

export const whatsappUrl = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
